import * as React from 'react';

import GenericVideo from '@lendi-jam/generic-video';

import { GenericVideoContent } from '#contentTypes/GenericVideo';

interface PrismicGenericImageProps {
  component: GenericVideoContent;
}

const PrismicGenericVideo: React.FC<PrismicGenericImageProps> = ({ component }) => {
  const PrismicVideoPrimary = component.primary;
  const srcMatch = PrismicVideoPrimary.video?.html ? PrismicVideoPrimary.video.html.match(/src="(.*?)"/g) : '';
  const srcUrl = srcMatch ? srcMatch[0] : '';
  const embedUrl = srcUrl.replace(/src="|"/g, '');

  return embedUrl ? <GenericVideo src={embedUrl} size={PrismicVideoPrimary.size} /> : null;
};

export default PrismicGenericVideo;
